/**
 * Local-day helpers for every date filter in the cashier app.
 *
 * The trap these exist to avoid: `new Date('2026-08-11')` parses a bare
 * `<input type="date">` value as UTC midnight, so on a UTC+8 tenant a
 * "from" filter starts the window at 8am local and silently hides every
 * morning sale. `new Date('2026-08-11T00:00:00')` (with a time part, no
 * zone) parses in LOCAL time — always build boundaries through these.
 */

/** Today's date as a `YYYY-MM-DD` string in the browser's local timezone. */
export function todayStr(): string {
  const d = new Date();
  const m = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}

/** Local midnight at the start of a `YYYY-MM-DD` day. */
export function startOfLocalDay(dateStr: string): Date {
  return new Date(`${dateStr}T00:00:00`);
}

/** The last millisecond of a `YYYY-MM-DD` day, local time (inclusive end). */
export function endOfLocalDay(dateStr: string): Date {
  return new Date(`${dateStr}T23:59:59.999`);
}
